import React from 'react';
import { Calendar, MapPin, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const IndiaBookRecords = () => {
  const records = [
    {
      title: "Maximum authors contributing to a book on covid-19 and its impact",
      date: "05 JUNE 2021",
      place: "Chennai",
      description: "The record for the maximum number of authors contributing to a book on COVID-19 and its impact was set by ESN Publications, India, under the guidance of J. Banuchandar, Founder and Chairman. A total of 1,498 authors across the world contributed articles to the book titled 'COVID-19 AND ITS IMPACT' (ISBN: 978-81-947019-4-1), which aims to establish the impact of COVID-19 on various Multidisciplinary Researches like Medical, Engineering, Arts, Science, Society Environment, Literature.",
      images: ["/records/india-book/indianbook of record.png"]
    },
    {
      title: "7575 Poems",
      date: "30TH JULY 2022",
      place: "Chennai",
      description: "The Record is an international anthology of work by poets from all various countries. With this book you can discover the world through its keenest observers, political activists and most articulate wordsmiths. There's something for every taste: new voices as well as the world's greats, rappers and spoken word artists and poets and storytellers. The Record marks the first time '7575 Poems' in Multiple Languages from so many countries that have been gathered together in one anthology.",
      images: ["/records/india-book/7575.png"]
    }
  ];

  return (
    <div style={{ backgroundColor: 'var(--bg-page)', minHeight: '100vh', padding: '80px 0' }}>
      <div className="container-custom">
        <Link to="/records" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: 'var(--brand-primary)', textDecoration: 'none', marginBottom: '30px', fontWeight: '600' }}>
          <ArrowLeft size={20} />
          <span>Back to Records</span>
        </Link>
        <h1 className="heading-1" style={{ marginBottom: '50px', textAlign: 'center' }}>INDIA BOOK OF RECORDS</h1>
        
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          {records.map((record, index) => (
            <div key={index} style={{ backgroundColor: 'var(--bg-card)', border: '1px solid var(--border-medium)', borderRadius: '16px', padding: '50px', marginBottom: '50px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
              <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                <div style={{ display: 'inline-block', backgroundColor: '#ff6b35', color: 'white', padding: '8px 20px', borderRadius: '25px', fontSize: '0.9rem', fontWeight: 'bold', marginBottom: '20px' }}>
                  INDIA BOOK OF RECORDS
                </div>
                <h2 className="heading-2" style={{ color: 'var(--brand-primary)', fontSize: '1.8rem', marginBottom: '10px' }}>{record.title}</h2>
              </div>
              
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '40px' }}>
                {record.images.map((image, imgIndex) => (
                  <div key={imgIndex} style={{ maxWidth: '600px', width: '100%' }}>
                    <img src={image} alt={`${record.title} ${imgIndex + 1}`} style={{ width: '100%', height: '400px', objectFit: 'contain', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.15)', border: '2px solid var(--border-medium)' }} />
                  </div>
                ))}
              </div>
              
              <div style={{ display: 'flex', justifyContent: 'center', gap: '50px', marginBottom: '40px', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', backgroundColor: 'var(--bg-page)', padding: '12px 20px', borderRadius: '25px' }}>
                  <Calendar size={22} color="var(--brand-primary)" />
                  <span style={{ fontWeight: '600', fontSize: '1rem' }}>{record.date}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', backgroundColor: 'var(--bg-page)', padding: '12px 20px', borderRadius: '25px' }}>
                  <MapPin size={22} color="var(--brand-primary)" />
                  <span style={{ fontWeight: '600', fontSize: '1rem' }}>{record.place}</span>
                </div>
              </div>
              
              <div style={{ backgroundColor: 'var(--bg-page)', padding: '30px', borderRadius: '12px', border: '1px solid var(--border-medium)' }}>
                <p className="body-medium" style={{ lineHeight: '1.8', textAlign: 'justify', fontSize: '1.1rem', margin: 0 }}>
                  {record.description}
                </p>
              </div>
            </div>
          ))}

          <div style={{ backgroundColor: 'var(--bg-page)', padding: '30px', borderRadius: '12px', border: '1px solid var(--border-medium)', marginTop: '20px' }}>
            <p className="body-medium" style={{ lineHeight: '1.8', textAlign: 'justify', fontSize: '1.1rem', margin: 0 }}>
              ESN Publications set this record with the maximum number of authors contributing to a book on COVID-19 and its impact. The project brought together 1,498 authors worldwide and highlights the scope of our global research collaboration.
            </p>
            <div style={{ marginTop: '24px', textAlign: 'center' }}>
              <a
                href="https://indiabookofrecords.in/maximum-authors-contributing-to-a-book-on-covid-19-and-its-impact/"
                target="_blank"
                rel="noreferrer noopener"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '14px 28px',
                  borderRadius: '9999px',
                  backgroundColor: '#ffb703',
                  color: '#102a43',
                  fontWeight: '700',
                  textDecoration: 'none',
                  boxShadow: '0 12px 30px rgba(255, 181, 3, 0.2)',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                }}
                onMouseEnter={(event) => { event.currentTarget.style.transform = 'translateY(-2px)'; event.currentTarget.style.boxShadow = '0 18px 40px rgba(255, 181, 3, 0.28)'; }}
                onMouseLeave={(event) => { event.currentTarget.style.transform = 'translateY(0)'; event.currentTarget.style.boxShadow = '0 12px 30px rgba(255, 181, 3, 0.2)'; }}
              >
                View Official Record
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default IndiaBookRecords;